// extracted by mini-css-extract-plugin
export default {"desktopScanner":"ScannerItemDesktop_desktopScanner__RzLd6"};